import {  OnInit, OnDestroy, HostBinding } from '@angular/core';

export abstract class BaseAppComponent {

   public cssClass = 'fixed-sidebar fixed-nav md-skin pace-done';

  minimalize() {
    const minimalizeClass = " mini-navbar";
    let position = this.cssClass.indexOf(minimalizeClass);
    if (position < 0) {
      this.cssClass = this.cssClass + minimalizeClass;
    } else {
      this.cssClass = this.cssClass.substring(0, position) + this.cssClass.substring(position + minimalizeClass.length);
    }
  }

static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cssClass': [{ type: HostBinding, args: ['class', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
